import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { portalApi } from "@/lib/portalApi";

const Ctx = createContext(null);

export function PortalAuthProvider({ children }) {
  const [account, setAccount] = useState(null);
  const refresh = useCallback(async () => {
    if (!localStorage.getItem("pressops_portal_token")) return setAccount(false);
    try { setAccount((await portalApi.get("/auth/me")).data); } catch { setAccount(false); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  const start = (data) => { localStorage.setItem("pressops_portal_token", data.token); setAccount(data.account); return data.account; };
  const login = async (email, password) => start((await portalApi.post("/auth/login", { email, password })).data);
  const setPassword = async (token, password) => start((await portalApi.post("/auth/set-password", { token, password })).data);
  const logout = async () => {
    try { await portalApi.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("pressops_portal_token");
    setAccount(false);
  };
  return <Ctx.Provider value={{ account, login, logout, setPassword, refresh }}>{children}</Ctx.Provider>;
}

export const usePortalAuth = () => useContext(Ctx);
